import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthService} from './services/auth.service';
import {TokenInterceptor} from './services/token-interceptor';
import {AuthGuardService} from './services/auth-guard.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {HasClaimDirective} from './directives/has-claim.directive';
import {DynamicUtilService} from '../services/dynamic-util.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    HasClaimDirective
  ],
  providers: [
    // Provide AuthService once; libraries inject 'AUTH_SERVER' and must share that instance (AC-27).
    AuthService,
    {
      provide: 'AUTH_SERVER',
      useExisting: AuthService,
    },
    AuthGuardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ]
})
export class AuthModule {
}
